import { MutationTree } from 'vuex';
import { TemplatesState } from './types';

export const mutations: MutationTree<TemplatesState> = {
    setSmsTemplates:(state, data) => {
        state.smsTemplates = data
    },

    setSmsMultichannelTemplates:(state, data) => {
        state.smsMultichannelTemplates = data
    },

    setSmsTemplateItem:(state, data) => {
        state.smsTemplateItem = data
    },
};